import DigiobcanApi from '../../api/DigiobcanApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

type Params = {
  votingId: string;
};

export const getVotingResults = createQueryFn(
  QueryNameSpace.getVotingResults,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    if (!params) {
      throw new Error('Missing required params');
    }

    const data = await DigiobcanApi.getVotingResults(params.votingId);
    return data.questions;
  },
);
